import clsx from "clsx";
import { IconProps } from "@/types/icons";
import { createColorClasses } from "@/theme/colors";

export const TriangleDown = ({
  width = 13,
  height = 9,
  className,
  filled,
  color,
  decorative = false,
  ariaLabel = "Down triangle",
}: IconProps) => {
  const classes = createColorClasses({ color });
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill={filled ? "currentColor" : "none"}
      viewBox="0 0 13 9"
      className={clsx(className, classes)}
      aria-hidden={decorative ? "true" : "false"}
      aria-label={!decorative ? ariaLabel : undefined}
    >
      <path
        d="M12.1625 0.749999L7 9.05307L1.83747 0.75L12.1625 0.749999Z"
        stroke="currentColor"
      />
    </svg>
  );
};

